import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { number, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import Line from './Line';

const ReadProgressBar = ({
  read,
  total,
  readColor: readColorIn = null,
  unreadColor: unreadColorIn = null,
}) => {
  const theme = useTheme();
  const unreadColor = unreadColorIn || theme.palette.danger;
  const readColor = readColorIn || theme.palette.primary.main;
  const unread = total - read;
  const readPercent = parseInt((read * 100) / total, 10) || 0;
  const unreadPercent = parseInt(100 - readPercent, 10) || 0;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          pb: '5px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontWeight: 'bold', color: readColor }}>
          {`${read} (${readPercent}%)`}
        </Typography>
        <Typography color="secondary">
          {I18n.t('AnalyticsDrawer.Total', { count: total })}
        </Typography>
        <Typography sx={{ fontWeight: 'bold', color: unreadColor }}>
          {`${unread} (${unreadPercent}%)`}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          borderRadius: '5px',
          overflow: 'hidden',
        }}
      >
        <Line percent={readPercent} color={readColor} />
        {readPercent && unreadPercent ? <Box sx={{ width: 4 }} /> : null}
        <Line percent={unreadPercent} color={unreadColor} />
      </Box>
    </Box>
  );
};

ReadProgressBar.propTypes = {
  read: number.isRequired,
  total: number.isRequired,
  readColor: string,
  unreadColor: string,
};

export default ReadProgressBar;
